// src/utils/documentPages.js — doced-8f3a61c2 (Document editor, Stage 4: the estimate page)
//
// The website's copy of the per-company switch for the new full-page document editors
// (functions/utils/documentPages.js is the server's; documentPages.test.js runs both on the same
// inputs and fails if they ever disagree).
//
//   organizations/{org}.documentPagesEnabled = { estimates: true }
//
// MISSING = OFF: a page is on only when its entry is exactly `true`. Server-owned (firestore.rules
// orgServerOwnedFieldsUntouched); functions/scripts/setDocumentPages.js is the only writer, and it
// turns pages ON for Spatchy Test Company only. The web reads it from the live company snapshot
// (CrmApp's companySettings), so switching it takes effect without a reload.

export const DOCUMENT_PAGES_FLAG = 'documentPagesEnabled';

/** Is the full page on for this company and document type? Missing / anything but true = off. */
export function isDocumentPageOn(companySettings, pageType) {
    const map = companySettings && companySettings[DOCUMENT_PAGES_FLAG];
    if (!map || typeof map !== 'object' || Array.isArray(map)) return false;
    return map[pageType] === true;
}
